import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import TipoAmbienteManager from './components/tipoambientemanager';
import TipoClassAmbienteManager from './components/tipoclassambientemanager';
import EstadoManager from './components/estadomanager';
import ProjetoDesenhoManager from './components/projetodesenhomanager';
import TipoEnsinoManager from './components/tipoensinomanager';
import TipoProjetoManager from './components/tipoprojetomanager';
import TipoTurnoManager from './components/tipoturnomanager';
import TipoModalidadeManager from './components/tipomodalidademanager';
import PerfilManager from './components/PerfilManager';
import TipoEquipamentoManager from './components/tipoequipamentomanager';
import TipoManutencaiManager from './components/tipomanutencaomanager';
import TipoSolicitacaoManager from './components/tiposolicitacaomanager';
import VistoriaImagemManager from './components/vistoriaimagemmanager';
import SuperintendenciaManager from './components/superintendenciamanager';
import MunicipioManager from './components/municipiomanager';
import EscolaManager from './components/escolamanager';
import PavimentoManager from './components/pavimentomanager';
import AmbienteManager from './components/ambientemanager';
import StatusManager from './components/statusmanager';
import GerenciaManager from './components/gerenciamanager';
import ProjetoManager from './components/projetomanager';
import AmbienteEquipamentoManager from './components/ambienteequipamentomanager';
import TipoRepresentacaoManager from './components/tiporepresentacaomanager';
import Home from './components/home';
import ImagemManager from './components/imagemmanager';
import PavimentoImagemManager from './components/pavimentoimagemmanager';
import AmbienteImagemManager from './components/ambienteimagemmanager';
import SolicitacaoImagemManager from './components/solicitacaoimagemmanager';
import EnsinoAlunoManager from './components/ensinoalunomanager';
import SolicitacaoManager from './components/solicitacaomanager';
import AcompanhamentoManager from './components/acompanhamentomanager';
import DesenhoManager from './components/desenhomanager';
import AmbienteDesenhoManager from './components/ambientedesenhomanager';
import PavimentoDesenhoManager from './components/pavimentodesenhomanager';
import ManutencaoManager from './components/manutencaomanager';
import TipoRegularizacaoManager from './components/tiporegularizacaomanager';
import LogAuditoriaManager from './components/logauditoriamanager';
import ManutencaoVistoriaManager from './components/manutencaovistoriamanager';
import TipoMaterialTetoManager from './components/tipomaterialtetomanager';
import TipoMaterialPisoManager from './components/tipomaterialpisomanager';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import MapaEscola from './components/mapaEscola'
import AcaoManager from './components/acaomanager';
import RegionalManager from './components/regionalmanager';
import GerenciadorAprovacoes from './components/GerenciadorAprovacoes';
import PermissionRoute from './components/PermissionRoute';
import UsuarioManager from './components/usuariomanager';
import SensoresIoTAmbienteManager from './components/SensoresIoTAmbienteManager';
import TipoSensorManager from './components/TipoSensorManager';
import AmbienteSensorManager from './components/AmbienteSensorManager';
import VideoManager from './components/videomanager';
import QuestionarioManager from './components/questionariomanager';
import UploadPage from './components/UploadPage';
import SolucaoInstitucionalManager from './components/solucaoinstitucionalmanager';
import './App.css';
import { jwtDecode } from 'jwt-decode';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken = jwtDecode(token);
    // Verifica se o usuário tem a permissão para ACESSAR_DATA_MANAGER
    if (!decodedToken.permissions || !decodedToken.permissions.includes('ACESSAR_DATA_MANAGER')) {
      // Se não tiver, limpa o localStorage e redireciona para o login
      localStorage.clear();
      return <Navigate to="/login" />;
    }
    return children;
  } catch (error) {
    // Token inválido ou expirado
    console.error("Token inválido ou expirado:", error);
    localStorage.clear();
    return <Navigate to="/login" />;
  }
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? <Navigate to="/" /> : children;
};

const AdminManagerRoute = ({ children }) => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    return <Navigate to="/login" />;
  }

  try {
    const decodedToken = jwtDecode(token);
    if (decodedToken.id_perfil === 1 || decodedToken.id_perfil === 2) {
      return children;
    } else {
      return <Navigate to="/" />;
    }
  } catch (error) {
    console.error("Token inválido ou expirado:", error);
    localStorage.clear();
    return <Navigate to="/login" />;
  }
};

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
          <Route path="/reset-password/:token" element={<PublicRoute><ResetPassword /></PublicRoute>} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/aprovacoes" element={<PermissionRoute permission="APROVAR_USUARIOS"><GerenciadorAprovacoes /></PermissionRoute>} />
          <Route path="/tipo-ambiente" element={<PrivateRoute><TipoAmbienteManager /></PrivateRoute>} />
          <Route path="/tipo-class-ambiente" element={<PrivateRoute><TipoClassAmbienteManager /></PrivateRoute>} />
          <Route path="/estado" element={<PrivateRoute><EstadoManager /></PrivateRoute>} />
          <Route path="/projeto-desenho" element={<PrivateRoute><ProjetoDesenhoManager /></PrivateRoute>} />
          <Route path="/tipo-ensino" element={<PrivateRoute><TipoEnsinoManager /></PrivateRoute>} />
          <Route path="/tipo-projeto" element={<PrivateRoute><TipoProjetoManager /></PrivateRoute>} />
          <Route path="/tipo-turno" element={<PrivateRoute><TipoTurnoManager /></PrivateRoute>} />
          <Route path="/tipo-modalidade" element={<PrivateRoute><TipoModalidadeManager /></PrivateRoute>} />
          <Route path="/perfis" element={<PrivateRoute><PerfilManager /></PrivateRoute>} />
          <Route path="/tipo-equipamento" element={<PrivateRoute><TipoEquipamentoManager /></PrivateRoute>} />
          <Route path="/tipo-manutencao" element={<PrivateRoute><TipoManutencaiManager /></PrivateRoute>} />
          <Route path="/tipo-solicitacao" element={<PrivateRoute><TipoSolicitacaoManager /></PrivateRoute>} />
          <Route path="/vistoria-imagem" element={<PrivateRoute><VistoriaImagemManager /></PrivateRoute>} />
          <Route path="/manutencao-vistoria" element={<PrivateRoute><ManutencaoVistoriaManager /></PrivateRoute>} />
          <Route path="/superintendencia" element={<PrivateRoute><SuperintendenciaManager /></PrivateRoute>} />
          <Route path="/municipio" element={<PrivateRoute><MunicipioManager /></PrivateRoute>} />
          <Route path="/escola" element={<PrivateRoute><EscolaManager /></PrivateRoute>} />
          <Route path="/pavimento" element={<PrivateRoute><PavimentoManager /></PrivateRoute>} />
          <Route path="/ambiente" element={<PrivateRoute><AmbienteManager /></PrivateRoute>} />
          <Route path="/status" element={<PrivateRoute><StatusManager /></PrivateRoute>} />
          <Route path="/gerencia" element={<PrivateRoute><GerenciaManager /></PrivateRoute>} />
          <Route path="/projeto" element={<PrivateRoute><ProjetoManager /></PrivateRoute>} />
          <Route path="/regional" element={<PrivateRoute><RegionalManager /></PrivateRoute>} />
          <Route path="/usuario" element={<AdminManagerRoute><UsuarioManager /></AdminManagerRoute>} />
          <Route path="/sensores-iot-ambiente" element={<PrivateRoute><SensoresIoTAmbienteManager /></PrivateRoute>} />
          <Route path="/tipo-sensor" element={<PrivateRoute><TipoSensorManager /></PrivateRoute>} />
          <Route path="/ambiente-sensor" element={<PrivateRoute><AmbienteSensorManager /></PrivateRoute>} />
          <Route path="/ambiente-equipamento" element={<PrivateRoute><AmbienteEquipamentoManager /></PrivateRoute>} />
          <Route path="/tipo-representacao" element={<PrivateRoute><TipoRepresentacaoManager /></PrivateRoute>} />
          <Route path="/imagem" element={<PrivateRoute><ImagemManager /></PrivateRoute>} />
          <Route path="/pavimento-imagem" element={<PrivateRoute><PavimentoImagemManager /></PrivateRoute>} />
          <Route path="/ambiente-imagem" element={<PrivateRoute><AmbienteImagemManager /></PrivateRoute>} />
          <Route path="/tipo-material-teto" element={<PrivateRoute><TipoMaterialTetoManager /></PrivateRoute>} />
          <Route path="/tipo-material-piso" element={<PrivateRoute><TipoMaterialPisoManager /></PrivateRoute>} />
          <Route path="/solicitacao-imagem" element={<PrivateRoute><SolicitacaoImagemManager /></PrivateRoute>} />
          <Route path="/ensino-aluno" element={<PrivateRoute><EnsinoAlunoManager /></PrivateRoute>} />
          <Route path="/solicitacao" element={<PrivateRoute><SolicitacaoManager /></PrivateRoute>} />
          <Route path='/acompanhamento' element={<PrivateRoute><AcompanhamentoManager /></PrivateRoute>} />
          <Route path='/desenho' element={<PrivateRoute><DesenhoManager /></PrivateRoute>} />
          <Route path='/ambiente-desenho' element={<PrivateRoute><AmbienteDesenhoManager /></PrivateRoute>} />
          <Route path='/pavimento-desenho' element={<PrivateRoute><PavimentoDesenhoManager /></PrivateRoute>} />
          <Route path='/manutencao' element={<PrivateRoute><ManutencaoManager /></PrivateRoute>} />
          <Route path='/tipo-regularizacao' element={<PrivateRoute><TipoRegularizacaoManager /></PrivateRoute>} />
          <Route path='/log-auditoria' element={<PrivateRoute><LogAuditoriaManager /></PrivateRoute>} />
          <Route path='/mapaEscola/:id' element={<PrivateRoute><MapaEscola /></PrivateRoute>} />
          <Route path="/acao" element={<PrivateRoute><AcaoManager /></PrivateRoute>} />
          <Route path="/solucao-institucional" element={<PrivateRoute><SolucaoInstitucionalManager /></PrivateRoute>} />
          <Route path="/video" element={<PrivateRoute><VideoManager /></PrivateRoute>} />
          <Route path="/questionario" element={<PrivateRoute><QuestionarioManager /></PrivateRoute>} />
          <Route path="/upload-imagem" element={<PrivateRoute><UploadPage /></PrivateRoute>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
